import { observable } from 'mobx';

export interface ShareholderTicketFeeArgs {
  id: number;
  organization_id: number;
  ana?: number;
  jal?: number;
  sfj?: number;
  route_text: string;
  discounted_ana: number;
  discount_ana_limit: number;
}

class ShareholderTicketFee {
  @observable id: number;
  @observable organizationId: number | null = null;
  @observable ana: number | null;
  @observable jal: number | null;
  @observable sfj: number | null;
  @observable routeText: string;
  @observable discountedAna: number;
  @observable discountAnaLimit: number;

  constructor(args: ShareholderTicketFeeArgs) {
    this.id = args.id;
    this.organizationId = args.organization_id > 0 ? args.organization_id : null;
    this.ana = args.ana ?? null;
    this.jal = args.jal ?? null;
    this.sfj = args.sfj ?? null;
    this.routeText = args.route_text;
    this.discountedAna = args.discounted_ana;
    this.discountAnaLimit = args.discount_ana_limit;
  }

  setOrganizationId(organizationId: number | null) {
    this.organizationId = organizationId;
    app.render();
  }
}

export default ShareholderTicketFee;
